import { DatePipe } from "@angular/common";
import { CommissionEnum } from "@enums/commission";
import { CommissionType } from "@models/reports/reports";
import { Table } from "@models/table";
import { DetailViewerModalComponent } from "@pages/shared/reports/commissions-report/detail-viewer-modal/detail-viewer-modal.component";
import { formatNumberToLocal } from "src/app/utils/format-number-to-local";

const datePipe = new DatePipe('pt-BR');

export const FILTER_PENDING_INVOICE: CommissionType = {
  id: CommissionEnum.PENDING_INVOICE,
  description: 'Aguardando emissão N.F.',
  startDateLabel: 'Data do cálculo inicial:',
  endDateLabel: 'Data do cálculo final:',
  componentModal: DetailViewerModalComponent
}

export const REPORT_PENDING_INVOICE : Partial<Table<any>> = {
    headers: [
      { key: "month", value: "Mês" },
      { key: "year", value: "Ano" },
      //{ key: "periodType", value: "Tipo de Período" },
      //{ key: "periodCode", value: "Código do Período" },
      { key: "period", value: "Período" },
      { key: "company", value: "Empresa" },
      { key: "calculatedValue", value: "Valor Calculado" },
    ],
    style: {
      table: { height: "500px" },
      data: [
        {
          key: "calculatedValue",
          transform: (value) => value ? `R$ ${ formatNumberToLocal(value) }` : "N/A"
        },
      ],
    },
    buttons: {read: true},
    messageWithoutDates: "Nenhum dado encontrado para 'Aguardando emissão N.F.'",
  }




